import { FormFieldBase, FormFieldType } from "src/app/common/components/dynamic-form-field/components/dynamic-form-light/models/form-field-base";
import { pdaRegistryConst } from "./constants/registry-const";
import { roles } from "./constants/role-const";

export const questions: FormFieldBase[] = [
  {
    controlType: FormFieldType[FormFieldType.DROPDOWN],
    key: "registry",
    label: "Registro",
    placeholder: "Selezionare il registro",
    chips: false,
    disabled: false,
    options: pdaRegistryConst,
    required: true,
    size: "col-sm-3"
  },
  {
    controlType: FormFieldType[FormFieldType.DROPDOWN],
    key: "role",
    label: "Ruolo",
    placeholder: "Selezionare il ruolo",
    chips: false,
    disabled: false,
    options: roles,
    required: true,
    size: "col-sm-3"
  },
  {
    controlType: FormFieldType[FormFieldType.SEARCHABLE_DROPDOWN],
    key: "officeCode",
    label: "Autorità giudiziaria - Sede",
    placeholder: "Selezionare l'autorità giudiziaria",
    chips: false,
    disabled: false,
    options: null,
    required: true,
    size: "col-sm-3"
  },
  {
    controlType: FormFieldType[FormFieldType.DROPDOWN],
    key: "cfDelegante",
    label: "Delegante",
    placeholder: "Selezionare il delegante",
    chips: false,
    disabled: false,
    options: null,
    required: false,
    size: "col-sm-3"
  },
  {
    controlType: FormFieldType[FormFieldType.TEXT],
    key: "party",
    label: "Parte",
    placeholder: "Inserire la parte",
    chips: false,
    disabled: false,
    size: "col-sm-6"
  },
  {
    controlType: FormFieldType[FormFieldType.TEXT],
    key: "judge",
    label: "Giudice",
    placeholder: "Inserire il giudice",
    chips: false,
    disabled: false,
    size: "col-sm-6"
  },
  {
    controlType: FormFieldType[FormFieldType.DATE],
    key: "registrationStartDate",
    label: "Data iscrizione da",
    placeholder: "Inserire data iscrizione da",
    chips: false,
    disabled: false,
    size: "col-sm-6"
  },
  {
    controlType: FormFieldType[FormFieldType.DATE],
    key: "registrationEndDate",
    label: "Data iscrizione a",
    placeholder: "Inserire data iscrizione a",
    chips: false,
    disabled: false,
    size: "col-sm-6"
  },
  {
    controlType: FormFieldType[FormFieldType.DATE],
    key: "hearingStartDate",
    label: "Data udienza da",
    placeholder: "Inserire data udienza da",
    chips: false,
    disabled: false,
    size: "col-sm-6"
  },
  {
    controlType: FormFieldType[FormFieldType.DATE],
    key: "hearingEndDate",
    label: "Data udienza a",
    placeholder: "Inserire data udienza a",
    chips: false,
    disabled: false,
    size: "col-sm-6"
  }
];
